import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useUserContext } from "src/contexts/userContext";

import * as API from "src/api/request";
import Swal from "sweetalert2";

const _ = require("lodash");

/** FRONTEND-ЭЭС НУУСАН ЦЭС (menu_link-ээр).
 *
 *  Цэс SSO-гийн usermenu-ээс ирдэг тул үндсэн тохиргоо нь SSO дээр
 *  (isactive=false). Тэнд хүрэхгүй үед эндээс түр хаана — sso_owner ч харахгүй.
 *
 *  ХСБ (хор саармагжуулах бүтээгдэхүүн) — зөвхөн «Тайлан» (product/report)
 *  үлдээв (2026-10-09, хэрэглэгчийн хүсэлт):
 *    product/control  — Ажилтнуудын лимит
 *    product/worker   — Ажилтнууд
 *    product/norm     — Ажилтнуудын норм
 *    product/plan     — Төлөвлөгөө
 *    product/register — Бүртгэл
 *  ⚠ Зөвхөн ЦЭС нуугдана — routers/product.js-ийн зам хэвээр тул шууд
 *    хаягаар орж болно. */
const HIDDEN_MENU_LINKS = [
  "product/control",
  "product/worker",
  "product/norm",
  "product/plan",
  "product/register",
];
const normLink = (l) =>
  String(l || "")
    .trim()
    .replace(/^\/+|\/+$/g, "")
    .toLowerCase();
const isHiddenLink = (l) => HIDDEN_MENU_LINKS.includes(normLink(l));

const Sidebar = () => {
  const { user, userDispatch, userType } = useUserContext();
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    if (user.tn !== 0) {
      // ── Эрх / userzone-ийн шалгалт ───────────────────────────────────
      // Backend-ийн `user.usermenu` нь cache-ээс ирдэг бөгөөд хэрэв
      // permission-аар хязгаарлагдаагүй бол бүх menu орсон байна.
      // Frontend дээрх шүүлт:
      //   1) `isactive: false` → нуугдана
      //   2) `isconst: true`  → бүх хэрэглэгчид үргэлж харагдана
      //                        (жишээ нь "Миний ХЭМАБ")
      //   3) Permission-аар хязгаарлагдсан menu (`menu_keys` бөглөсөн) бол
      //      хэрэглэгчийн roles-той тулгана. menu_keys нь permission key.
      //   4) Userzone-аар хязгаарлагдсан menu (`menu_iconp` дотор zone_id-ууд
      //      JSON-аар тэмдэглэгдсэн бол) тухайн хэрэглэгчийн userzone-той
      //      огтлолцох эсэхийг шалгана.
      //   5) Эцэст нь parent-н бүх child нь хаалттай бол parent ч нуугдана
      //      (`menu_link` нь "" эсвэл null бөгөөд хүүхэдгүй menu).
      const roles = Array.isArray(user.roles) ? user.roles : [];

      // sso_owner = програмын админ — permission/zone хязгаарлалтгүй БҮХ
      // (идэвхтэй) цэсийг харна. userContext-ийн ADMIN_ROLE-той нэгдмэл.
      const isOwner =
        _.includes(user.userroles, "sso_owner") ||
        _.includes(roles, "sso_owner");

      const isMenuAllowed = (m) => {
        if (m.isactive === false) return false;
        // Frontend-ээс нуусан цэс — sso_owner-оос ч ӨМНӨ шалгана
        if (isHiddenLink(m.menu_link)) return false;
        if (isOwner) return true;
        if (m.isconst === true) return true;
        // menu_keys нь permission key — байгаа бол role-той тааруулна
        if (m.menu_keys) {
          const keys = String(m.menu_keys)
            .split(",")
            .map((k) => k.trim())
            .filter(Boolean);
          if (keys.length && !keys.some((k) => roles.includes(k))) {
            return false;
          }
        }
        return true;
      };

      var allMenu = (user.usermenu || []).filter(isMenuAllowed);
      var parents = _.sortBy(
        allMenu.filter((a) => a.parent_id === 0),
        ["ordern"]
      );
      _.map(parents, (item) => {
        var children = _.orderBy(
          allMenu.filter((a) => a.parent_id === item.id),
          ["ordern"],
          ["asc"]
        );
        item.children = children;
      });
      // Хоосон parent-ыг алгасах: хүүхэдгүй бөгөөд өөрөө шууд navigatable
      // (menu_link бөглөгдсөн) биш бол UI-аас хасна.
      parents = parents.filter(
        (item) =>
          item.children.length > 0 ||
          (item.menu_link && item.menu_link !== "")
      );
      setMenu(parents);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.tn, user.usermenu, user.roles, user.userroles, user.userzone]);

  return (
    <aside className="main-sidebar app-sidebar sidebar-scroll">
      <div className="main-sidebar-header">
        <Link className="desktop-logo logo-light active" to="/">
          <img
            src="/img/logo.png"
            className="main-logo"
            alt=""
            onClick={() => {
              window.location = "https://digital.erdenetmc.mn";
            }}
          />
        </Link>
        <Link className="desktop-logo icon-logo active" to="/">
          <img
            src="/img/logo.png"
            className="logo-icon"
            alt=""
            onClick={() => {
              window.location = "https://digital.erdenetmc.mn";
            }}
          />
        </Link>
        <Link className="desktop-logo logo-dark active" to="/">
          <img
            src="/img/logo_white.png"
            className="main-logo dark-theme"
            alt="logo"
            onClick={() => {
              window.location = "https://digital.erdenetmc.mn";
            }}
          />
        </Link>
        <Link className="logo-icon mobile-logo icon-dark active" to="/">
          <img
            src="/img/logo_white.png"
            className="logo-icon dark-theme"
            alt="logo"
            onClick={() => {
              window.location = "https://digital.erdenetmc.mn";
            }}
          />
        </Link>
      </div>
      {/* /logo */}
      <div className="main-sidebar-loggedin">
        <div className="app-sidebar__user">
          <div className="dropdown user-pro-body flex flex-col items-center justify-center">
            <div className="user-pic">
              <img
                src={
                  "https://minio-action.erdenetmc.mn/emp/" + user.tn + ".jpg"
                }
                alt=""
                className="rounded-circle mCS_img_loaded"
                onError={(e) => {
                  e.target.src = "/assets/images/user.png";
                }}
              />
            </div>
            <div className="user-info text-center">
              <h6 className="mb-0 text-dark">{user.info.shortname}</h6>
              <span
                className="text-muted app-sidebar__user-name text-sm"
                style={{ whiteSpace: "pre-wrap" }}
              >
                {user.info.position_namemn}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar-navs">
        <ul className="nav nav-pills-circle">
          <li
            className="nav-item"
            data-toggle="tooltip"
            data-placement="top"
            data-original-title="Гарах"
          >
            <a
              href="/"
              className="nav-link text-center m-2"
              onClick={(e) => {
                e.preventDefault();
                API.logOut()
                  .then(() => {
                    userDispatch({ type: userType.LOG_OUT });
                    window.location = "https://digital.erdenetmc.mn";
                  })
                  .catch(() =>
                    Swal.fire({
                      icon: "warning",
                      title: "Гарах сервис ажиллахгүй байна.",
                      html: "",
                    })
                  );
              }}
            >
              <i className="fe fe-power" />
            </a>
          </li>
        </ul>
      </div>
      <div className="main-sidebar-body">
        <ul className="side-menu">
          {menu.map((item) => {
            return item.children.length === 0 ? (
              <li key={item.id} className="slide">
                <Link
                  className={
                    "side-menu__item" +
                    (user.current.menu1ID === item.id ? " active" : "")
                  }
                  to={"/" + item.menu_link}
                  onClick={() => {
                    userDispatch({
                      type: userType.CHANGE_MENU1_ID,
                      data: item.id,
                    });
                    userDispatch({
                      type: userType.CHANGE_MENU2_ID,
                      data: 0,
                    });
                    userDispatch({
                      type: userType.CHANGE_MENU_EXPANDED,
                      data: 0,
                    });
                    userDispatch({
                      type: userType.CHANGE_MENU_NAME,
                      data: item.caption,
                    });
                  }}
                >
                  <i
                    className={
                      "side-menu__icon" +
                      (item.description === null ? "" : " " + item.description)
                    }
                  />
                  <span className="side-menu__label text-xs">
                    {item.caption}
                  </span>
                </Link>
              </li>
            ) : (
              <li
                key={item.id}
                className={
                  "slide" +
                  (user.current.menuExpanded === item.id ? " is-expanded" : "")
                }
              >
                <a
                  className={
                    "side-menu__item" +
                    (user.current.menu1ID === item.id ? " active" : "")
                  }
                  data-toggle="slide"
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    userDispatch({
                      type: userType.CHANGE_MENU1_ID,
                      data: item.id,
                    });
                    userDispatch({
                      type: userType.CHANGE_MENU_EXPANDED,
                      data: user.current.menuExpanded === item.id ? 0 : item.id,
                    });
                  }}
                >
                  <i
                    className={
                      "side-menu__icon" +
                      (item.description === null ? "" : " " + item.description)
                    }
                  />
                  <span className="side-menu__label text-xs">
                    {item.caption}
                  </span>
                  <i className="angle fe fe-chevron-down" />
                </a>
                <ul className="slide-menu">
                  {item.children.map((children) => {
                    return (
                      <li key={children.id}>
                        <Link
                          className={
                            "slide-item" +
                            (user.current.menu2ID === children.id
                              ? " active"
                              : "")
                          }
                          to={"/" + children.menu_link}
                          onClick={() => {
                            userDispatch({
                              type: userType.CHANGE_MENU2_ID,
                              data: children.id,
                            });
                            userDispatch({
                              type: userType.CHANGE_MENU_NAME,
                              data: item.caption + " > " + children.caption,
                            });
                          }}
                        >
                          <span className="text-xs font-semibold">
                            {children.caption}
                          </span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          })}
        </ul>
      </div>
    </aside>
  );
};

export default React.memo(Sidebar);
